const promos = [
  {
    name: "phone",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491357/phone_fznttf.png",
  },
  {
    name: "earphone",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491457/headphones_dx7w9g.png",
  },
  {
    name: "speaker",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491260/speaker_jetzi6.png",
  },
  {
    name: "laptop",
    image:
      "https://res.cloudinary.com/de5it79dw/image/upload/v1648491384/lap_qyyy4c.png",
  },
];

export { promos };
